import { Link } from "react-router-dom";
import { platform_constants } from "./constants";

export default function Platform() {
  return (
    <section className="py-10 bg-white">
      <div className="container  px-3">
        <div className="text-center mb-8 space-y-5">
          <h2 className="text-[22px] lg:text-[36px] font-bold text-black">
            {platform_constants.title}
          </h2>
          <p className="text-[#222] md:text-xl max-w-[768px] mx-auto">
            {platform_constants.description}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-[18px] md:gap-8">
          {platform_constants.platforms.map((p) => (
            <div
              className="bg-[#EDF8FF] border-[0.5px] border-[#E7E7E7] rounded-xl p-3 md:!p-[24px] space-y-4"
              key={p.title}
            >
              <div>
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-48 object-contain"
                />
              </div>
              <h3 className="text-[20px] lg:text-[36px] font-bold text-black">
                {p.title}
              </h3>
              <p className="text-[#222] text-sm font-medium">{p.description}</p>
              <Link
                className="border border-primary_alt bg-white px-4 py-2.5 rounded-lg h-max block text-primary_alt font-medium w-max"
                to={p.link}
              >
                {p.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
